<template>
  <div>
    <button class="btn" :class="btnClasses" @click="openContactSupplierForm">
      <i class="fas fa-envelope"></i>
    </button>
    <b-modal
      id="contact-supplier-form"
      title="Contact Supplier"
      centered
      :hide-footer="true"
    >
      <p
        :class="[isApiError ? 'text-danger' : 'text-success']"
        class="mb-0 mt-0"
        v-if="apiResponseMessage"
      >
        {{ apiResponseMessage }}
      </p>
      <form @submit.prevent="submit">
        <div class="form-group">
          <label for="subject">Subject:</label>
          <input
            type="text"
            class="form-control"
            id="subject"
            v-model="form.subject"
            required
          />
        </div>
        <div class="form-group">
          <label for="subject">Phone (optional):</label>
          <input
            type="text"
            class="form-control"
            id="subject"
            v-model="form.pickup_mobile"
          />
        </div>
        <div class="form-group">
          <label for="message">Message:</label>
          <textarea
            class="form-control"
            id="message"
            v-model="form.message"
            required
          />
        </div>
        <button class="btn btn-primary">
          Send
          <b-spinner small v-if="isLoading"></b-spinner>
        </button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { contactSupplier } from '../../api/services/supplier'
export default {
  name: 'ContactButton',
  props: {
    btnClasses: {
      default: () => ['btn-sm', 'btn-primary'],
      type: Array
    },
    id: {
      required: true,
      type: Number
    },
    productId: {
      required: true,
      type: Number
    },
    hasMessage: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      isLoading: false,
      form: {},
      apiResponseMessage: '',
      isApiError: false
    }
  },
  mounted() {
    this.$eventBus.$off('contact-supplier')
    this.$eventBus.$on('contact-supplier', () => {
      this.openContactSupplierForm()
    })
  },
  methods: {
    async submit() {
      this.isLoading = true

      this.form.supplier_id = this.id
      this.form.product_id = this.productId || +this.$route.params.id
      this.form.pickup_email = this.$user.email

      try {
        let { data, status } = await contactSupplier(this.form)
        if (status === 200) {
          this.apiResponseMessage = data.message
          setTimeout(() => {
            this.$bvModal.hide('contact-supplier-form')
          }, 2000)
        } else {
          this.apiResponseMessage = data.error
          this.isApiError = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
        this.open = false
      }
    },
    openContactSupplierForm() {
      if (this.hasMessage) {
        localStorage.setItem('profile-active-tab', 1)
        localStorage.setItem('product-id', +this.$route.params.id)
        this.$router.push('/profile')
      } else {
        if (this.$isLoggedIn) {
          this.$bvModal.show('contact-supplier-form')
        } else {
          localStorage.setItem('login-redirect', 'contact-supplier')
          this.$bvModal.show('login-as')
        }
      }
    }
  }
}
</script>

<style scoped>
label {
  color: #000;
}
</style>
